import { UPDATE_FILE_CLASS } from './mutationTypes';

export default {
  update_operation_list(state, payload) {
    state.operationList = payload;
  },
  update_permission_list(state, payload) {
    state.permissionList = payload;
  },
  updateLoginData(state, payload) {
    state.loginData = payload;
  },
  [UPDATE_FILE_CLASS](state, payload) {
    state.fileClass = payload;
  },
};